export default __webpack_public_path__ + "static/media/S.f46d3e29.svg";